import { atom } from 'jotai';
import axiosService from './axios.service';
import { store } from './atom.service';

export interface NotificationPayload {
    _id: string;
    hackathon: string;
    session?: string;
    type: 'session-updated' | 'session-assignments' | 'on-stage' | 'voting-open' | 'last-call';
    title: string;
    body: string;
    link: string;
    readAt: Date | null;
    createdAt: Date;
}

export const notificationsAtom = atom<{ notifications: NotificationPayload[], unread: number }>({
    notifications: [],
    unread: 0
});

const apply = (data: any) => {
    const value = {
        unread: data.unread as number,
        notifications: (data.notifications as any[]).map(n => ({
            ...n,
            readAt: n.readAt ? new Date(n.readAt) : null,
            createdAt: new Date(n.createdAt)
        }))
    };
    store.set(notificationsAtom, value);
    return value;
}

export const getNotifications = async () => {
    const { data } = await axiosService.get('/api/notifications');
    return apply(data);
}

// omit ids to mark everything read
export const markNotificationsRead = async (ids?: string[]) => {
    const { data } = await axiosService.post('/api/notifications/read', { ids });
    return apply(data);
}
